export const CHANGE_PROGRESS = 'CHANGE_PROGRESS'
export const UPDATE_BATCHES = 'UPDATE_BATCHES'
export const UPDATE_BATCH = 'UPDATE_BATCH'
export const ADD_BATCH = 'ADD_BATCH'
export const UPDATE_AVAILABLE_BATCH_STATUSES_BY_VALUE = 'UPDATE_AVAILABLE_BATCH_STATUSES_BY_VALUE'
export const UPDATE_SAMPLE_BATCH_LIST = 'UPDATE_SAMPLE_BATCH_LIST'
export const CHANGE_BATCH_CURRENT_PAGE = 'CHANGE_BATCH_CURRENT_PAGE'
export const UPDATE_SAMPLE_BATCH = 'UPDATE_SAMPLE_BATCH'
export const REMOVE_SAMPLE_BATCH = 'REMOVE_SAMPLE_BATCH'
export const UPDATE_MISSING_SAMPLES = 'UPDATE_MISSING_SAMPLES'
export const UPDATE_CASES_WITH_MISSING_SAMPLES = 'UPDATE_CASES_WITH_MISSING_SAMPLES'
export const UPDATE_ALL_BATCHES = 'UPDATE_ALL_BATCHES'
export const UPDATE_BATCH_FILES = 'UPDATE_BATCH_FILES'
export const FULLFILL_BATCH = 'FULLFILL_BATCH'

